import { render, staticRenderFns } from "./Lgx243684920157239864.vue?vue&type=template&id=bda537ae&scoped=true&"
import script from "./Lgx243684920157239864.vue?vue&type=script&lang=js&"
export * from "./Lgx243684920157239864.vue?vue&type=script&lang=js&"
import style0 from "./Lgx243684920157239864.vue?vue&type=style&index=0&id=bda537ae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bda537ae",
  null
  
)

export default component.exports